'use strict';
angular.module('schoolLinqApp').directive('elementMap', function () {
	return {
		restrict: 'A',
		scope: { matchElement: '=' },
		require: 'ngModel',
		link: function (scope, element, attributes, ngModel) {
			// add a parser that will process each time the value is
			// parsed into the model when the user updates it.
			ngModel.$parsers.unshift(function (value) {
				if (scope.matchElement && value) {
					// validate
					ngModel.$setValidity('elementMap', scope.matchElement.split('.').length === value.split('.').length);
				}

				// if it's valid, return the value to the model,
				// otherwise return undefined.
				return value;
			});

			// add a formatter that will process each time the value
			// is updated on the DOM element.
			ngModel.$formatters.unshift(function (value) {
				if (scope.matchElement && value) {
					// validate
					ngModel.$setValidity('elementMap', scope.matchElement.split('.').length === value.split('.').length);
				}

				// return the value or nothing will be written to the DOM.
				return value;
			});
		},
	};
});
